export class QuotaDetail {
    public maxQuota: number;
    public maxQuotaDate?: Date;
    public remainingQuota: number;
    public totalQuota: number;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.maxQuota = json.maxQuota;
            this.maxQuotaDate = json.maxQuotaDate;
            this.remainingQuota = json.remainingQuota;
            this.totalQuota = json.totalQuota;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/quotaDetails.ts